<!--
 * @Description: 
 * @Author: xgx
 * @Date: 2023-03-03 17:22:18
 * @LastEditors: xgx
 * @LastEditTime: 2023-05-10 15:29:59
-->
<template>
<a-spin :spinning='loading'>
    <div class="gaojian-box">
        <a-table :scroll="{ y: height }" :pagination="false" :columns="columns" :data-source="list" bordered>
            <template slot="type"  slot-scope="text,record">
                <a-radio-group @change="change($event,record.id)" :default-value="text">
                    <a-radio :value="0">
                        可查看全站稿件
                    </a-radio>
                    <a-radio :value="1">
                        仅查看栏目权限范围内的稿件
                    </a-radio>
                </a-radio-group>
            </template>
        </a-table>
        <a-button v-if="codeData.indexOf('290') != -1"  @click="save" class="btn-box" type="primary">保存</a-button>
    </div>
</a-spin>
</template>
<script>
import { selectManuscriptListByOrgId, saveManuscriptConfig } from "./organizational_structure";
import { message } from "ant-design-vue";
export default {
    props: {
    orgId: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
     columns:[
        {
            title: '站点名称',
            dataIndex: 'siteName',
            key: 'siteName',
            
        },
        {
            title: '稿件库数据范围',
            dataIndex: 'type',
            key: 'type',
            scopedSlots: { customRender: 'type' },
        },
        
        ],
        list:[],
        loading:false,
        codeData:[],
        height:0,
    };
  },
  components: {
    
  },
  mounted() {
     this.codeData = JSON.parse(sessionStorage.getItem("menuData"));
   this.selectList()
  },
  watch:{
    orgId(){
        this.selectList();
    }
  },
  methods: {
        change(e,id){
            console.log(e,id)
            this.list.map(item=>{
                if(item.id==id){
                    item.type = e.target.value
                }
            })
        },
        save(){
            this.loading = true;
            saveManuscriptConfig(this.list).then(res=>{
                if(res.code == 0){
                    this.loading = false;
                    message.success(res.msg)
                    this.selectList()
                }
            })
        },
        selectList(){
            this.loading = true;
            this.list = []
            selectManuscriptListByOrgId({id:this.orgId}).then(res=>{
                if(res.data.length == 0){
                    message.error('请先设置站点权限')
                }
                this.list = res.data
                if(this.list.length > 0){
                    this.height = document.documentElement.clientHeight - 500;
                window.onresize = () => {
                    return (() => {
                      this.height = document.documentElement.clientHeight - 500;
                    })();
                  };
                }
                this.loading = false;
            })
        }
    },
};
</script>
<style lang="less" scoped>
.gaojian-box{
    margin: 24px;
}
.ant-btn-primary{
    margin-top: 40px;
}
/deep/ .ant-table-tbody > tr > td{
    padding: 9.5px 16px;
    color: #303133;
}
/deep/ .ant-table-thead > tr > th{
   padding: 12.5px 16px;
}
/deep/ .ant-table-fixed-left{
  border-right: 1px solid rgba(228, 231, 237, 1);
}
/deep/ .ant-table-fixed-right{
    border-left: 1px solid rgba(228, 231, 237, 1);
    
}
/deep/ .ant-table-fixed-right .ant-table-tbody > tr > td{
   padding: 9.5px 24px;
}
/deep/ .ant-table-fixed-right .ant-table-thead > tr:first-child > th:last-child{
  padding: 12.5px 24px;
  
}
/deep/ .ant-table-thead > tr > th{
    background-color: rgba(245, 247, 250, 1);
}
/deep/ .ant-table-thead > tr{
   background-color: rgba(245, 247, 250, 1);
}
/deep/ .ant-table-hide-scrollbar{
  background-color: rgba(245, 247, 250, 1);
  
}
/deep/ .ant-table-column-title{
    color: #606266;
}
/deep/ .ant-table-fixed-left table,.ant-table-fixed-right table{
    width: min-content;
    }
    /deep/ .ant-table-row-cell-ellipsis {
      max-width: 1px !important;
      overflow: hidden !important;
      white-space: nowrap !important;
      -o-text-overflow: ellipsis !important;
      text-overflow: ellipsis !important;
  }

  /deep/ .el-empty__description p{
    color: rgba(16, 16, 16, 1);
    font-size: 16px;
    text-align: left;
    font-family: Roboto-regular;
  }
  /deep/ .el-empty{
    padding: 11px 0px 15px 0px;
  }
  /deep/ .el-empty__description{
    margin-top: 10px;
  }
  /deep/ .ant-table-placeholder{
    border-bottom: none;
  }

   /deep/ tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td, .ant-table-tbody > tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td, .ant-table-thead > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td, .ant-table-tbody > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td {
    background:#fafafa !important;
  }
  /deep/ tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td{
    background:#fafafa !important;
  }
</style>